import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const regimesForRegister = api(async (registerId) =>
    query(
        gql`
            query GetRegimesForRegister($registerId: String!) {
                getRegimesForRegister(registerId: $registerId) {
                    regimeId
                    title
                    syncState
                    registerModified
                    regimeModified
                    syncedAt
                    syncedRegisterLastModified
                }
            }
        `,
        {
            registerId,
        },
        {
            returns: "getRegimesForRegister",
        }
    )
)
